<template>
  <div class="tab-header">
    <div class="container-fluid">
      <ul class="nav nav-tabs narrow" role="tablist" id="business-tab">
        <li class="nav-item" v-for="(item, i) in tree" :class="{
          'dropdown': !item.child === false && item.child.length,
          'active': currentTab == item.key || (currentTab.indexOf(item.key) === 0),
          'd-none': setDisplay(item.showType)
        }" :id="`tree-item-${i}`" :key="`tree-item-${i}`">
          <a v-if="!item.child === false && item.child.length" data-toggle="dropdown" class="nav-link dropdown-toggle"
            role="button" aria-haspopup="true" aria-expanded="false">{{ item.name }}</a>
          <router-link :to="item.path" v-else class="nav-link" role="button" :data-item="item.key"
            :data-parent="item.key">{{ item.name }}</router-link>

          <ul v-if="!item.child === false && item.child.length" class="dropdown-menu"
            :aria-labelledby="`tree-item-${i}`">
            <li class="dropdown-item" v-for="(val, j) in item.child" :key="`tree-${i}-${j}`"
              :class="{ 'd-none': setDisplay(val.showType, val.allowRoles) ? true : val.isShow }">
              <router-link :to="val.path" role="tab" data-toggle="tab" :data-item="val.key" :data-parent="item.key">
                {{ val.name }}
                <i class="text-green float-right">❯</i>
              </router-link>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { getChangeTraceKeep } from '@/service'

export default {
  name: 'TabHeader',
  data() {
    return {
      currentTab: 'key-1',
      tree: [
        {
          path: '/manager/tab/1',
          key: 'key-1',
          name: '服務件調撥',
          showType: ['01'],
        },
        {
          //區部調撥(跨單位調撥)：區部協理、被授權的區部專員可使用
          path: '/seniormanager/tab/1',
          key: 'key-1',
          name: '服務件調撥',
          showType: ['07', '08'],
        },
        {
          //區部的調撥紀錄查詢：區部協理、區部專員可使用
          path: '/seniormanager/tab/2',
          key: 'key-2',
          name: '調撥記錄查詢',
          showType: ['02', '07', '08'],
        },
        {
          path: '/submanager/tab/1',
          key: 'key-1',
          name: '小額調撥',
          showType: ['03'],
        },
        {
          path: '/manager/tab/0',
          key: 'key-0',
          name: '覆核作業',
          showType: ['01', '03', '04'],
        },
        {
          path: '/submanager/tab/2',
          key: 'key-2',
          name: '調撥/覆核紀錄查詢',
          showType: ['03'],
        },
        {
          path: '/manager/tab/3',
          key: 'key-3',
          name: '調撥/覆核記錄查詢',
          showType: ['01'],
        },
        {
          path: '/manager/tab/4',
          key: 'key-4',
          name: '強制調撥統計表',
          showType: ['01', '02', '04', '07', '08'],
        },
        {
          path: '5',
          key: 'key-5',
          name: '實質接觸統計表',
          showType: ['01', '02', '03', '04', '07', '08'],
          child: [
            {
              path: '/manager/tab/5-1',
              key: 'key-5-1',
              name: '異動後實質接觸追蹤表',
              showType: ['01', '02', '03', '04', '07', '08'],
              isShow: false,
            },
            {
              // 異動後實質接觸追蹤表KEEP(凍結統計期間)
              path: '/manager/tab/5-3',
              key: 'key-5-3',
              name: '異動後實質接觸追蹤表',
              showType: ['01', '02', '03', '04', '07', '08'],
              isShow: false,
            },
            {
              path: '/manager/tab/5-2',
              key: 'key-5-2',
              name: '轄下異動後實質接觸明細',
              showType: ['01', '03'],
              isShow: false,
            }
          ]
        },
        {
          path: '6',
          key: 'key-6',
          name: '服務件資訊查詢',
          showType: ['01', '02', '03', '04', '07', '08'],
          child: [
            {
              path: '/manager/tab/6-1',
              key: 'key-6-1',
              name: '建議調撥(全單位未訪件)',
              showType: ['01', '02', '04', '07', '08'],
              isShow: true,  // 2026/6/11 服務件節奏調整，為聚焦外勤單位主管管理追蹤方向及資訊一致性，隱藏及調整相關報表，隱藏建議調撥(單位未訪件)
            },
            {
              path: '/manager/tab/6-4',
              key: 'key-6-4',
              name: '轄下未訪件接觸追蹤表',
              showType: ['01', '02', '04', '07', '08'],
            },
            {
              // 處長
              path: '/manager/tab/6-4-director',
              key: '6-4-director',
              name: '轄下未訪件接觸追蹤表',
              showType: ['03'],
              allowRoles: ['A015'],
            },
            {
              path: '/manager/tab/6-2',
              key: 'key-6-2',
              name: '轄下未訪/準未訪件資訊',
              showType: ['01', '03'],
            },
            {
              path: '/manager/tab/6-3',
              key: 'key-6-3',
              name: '轄下服務件資訊',
              showType: ['01', '02', '03', '07', '08'],
            },
            {
              path: '/manager/tab/6-5',
              key: 'key-6-5',
              name: '轄下準未訪件接觸追蹤表',
              showType: ['01', '02', '04', '07', '08']
            }
          ]
        }
      ],
    }
  },
  computed: {
    ...mapGetters([
      'UserRight'
    ]),
    // 判斷角色 type
    computedShowType() {
      const roleId = this.$store.state.userInfo.roleId
      const divNo = this.$store.state.userInfo.divNo
      const functionId = this.$store.state.userInfo.functionId
      const roles = this.$store.state.userInfo.roles

      // 經理 type = 01
      if (roleId == 'SALES_MANAGER_02' || (roleId == 'SALES_MANAGER_06' && functionId && functionId.includes('3'))) { return '01' }

      // 區部專員 type = 02
      if (roleId == 'SALES_01' && !roles.hasOwnProperty('RLMX009')) { return '02' }

      // 課長&組訓&區處主管 type = 03
      if (roleId == 'SALES_MANAGER_03' || roleId == 'SALES_MANAGER_04' || roleId == 'SALES_MANAGER_05' || roleId == 'SALES_MANAGER_06') { return '03' }

      // 維護單位 type = 04   // 尚未設定
      //if (roleId == 'MAINTENANCE_UNIT') {return '01'}

      // 權責單位 type = 05  // 尚未設定
      //if (roleId == 'BUSINESS_UNIT') {return '01'}
      if (divNo == '0500100') { return '04' }

      // 企劃單位 type = 06  // 尚未設定
      //if (roleId == 'PLANNING_UNIT') {return '01'}

      // 區部協理 type = 07
      if (roleId == 'SALES_MANAGER_01') { return '07' }

      // 被授權可以執行服務件調撥的區部專員(RLMX009) type = 08 (需要包含02的權限)
      if (roleId == 'SALES_01' && roles.hasOwnProperty('RLMX009')) { return '08' }

      return '02'
    },
  },
  methods: {
    setDisplay(type, allowRoles) {  // 判斷權限顯示或隱藏
      // 針對 allowRoles 作權限控制處理
      if (allowRoles && allowRoles.length > 0) {
        const currentCategoryId = this.$store.state.userInfo.userCategoryId
        if (!allowRoles.includes(currentCategoryId)) {
          return true 
        }
      }

      if (type.includes(this.computedShowType)) {
        return false
      } else {
        return true
      }
    },
  },
  async beforeMount() {
    let path = this.$route.path.split(/\//g)
    path.reverse()
    this.currentTab = `key-${path[0]}`
    await getChangeTraceKeep(this.$store.state.userInfo.id, "0", "0", "2022-01-01", "2022-01-01", "").then(result => {
      if (result.header && "200" == result.header.status) {
        // 控制顯示[異動後實質接觸追蹤表]或[異動後實質接觸追蹤表KEEP(凍結統計期間使用)]
        this.tree[8].child[0].isShow = result.body.is_show.option_name == "Y";
        this.tree[8].child[1].isShow = result.body.is_show.option_name != "Y";
      }
    });
  }
}
</script>

<style></style>
